import React from 'react';
import "../terms.component/terms.style.css"
import chipsImage from "../../assets/compressed/logoWildChip-min.png"
import SEO from '../../SEO';

const Privacy: React.FC = () => {
    // Define safe zones for chips (avoiding text content)
    const chipPositions = Array.from({ length: 40 }, () => ({
        top: `${Math.floor(Math.random() * 1000)}px`,
        left: `${Math.random() < 0.5 
            ? Math.floor(Math.random() * 20) // 0-20%
            : Math.floor(Math.random() * 40) + 80}%`, // 60-100%
        rotation: `${Math.random() * 360}deg`,
        opacity: 0.5 + (Math.random() * 0.5) // Random between 0.5 and 0.8
    }));

    return (
        <>
            <SEO 
                title="Privacy Policy - Wild Chips Poker"
                description="Read Wild Chips Poker's privacy policy. Learn how we collect, use, and protect your personal information while playing our jungle-themed poker game."
                keywords="wild chips poker privacy policy, poker game privacy, data protection, privacy terms, poker game data policy"
                ogImage="/images/bgAbout-min.png"
                canonicalUrl="https://wildchipspoker.com/privacy"
            />
            <div className="all-pages-padding terms-container-bg">
                <div className="random-chips-container">
                    {chipPositions.map((position, index) => (
                        <img 
                            key={index}
                            src={chipsImage} 
                            alt="Chips" 
                            style={{ 
                                position: 'absolute',
                                ...position,
                                transform: `rotate(${position.rotation})`,
                                opacity: position.opacity
                            }} 
                        />
                    ))}
                </div>
                <div className="terms-container">
                    <h1>Privacy Policy</h1>
                    {/* <p className="version">Current Version: 1</p> */}
                    
                    <section>
                        <h2>POLICY STATEMENT</h2>
                        <p>The Website, wildchipspoker.com game client and the wildchipspoker  mobile app (collectively referred to as "applications"), are operated by George Abdulaziz(hereinafter referred to as "WildChipsPoker", "we", "us" or "our" or "Company") under the brand name of wildchipspoker.com  and we are committed to protecting the personal information entrusted to us by our players.</p>
                    </section>

                    <section>
                        <h2>REGARDING CHILDREN AND MINORS</h2>
                        <p>Our website, applications and the services offered on our website and applications are not directed to individuals under the age of 18. We will not knowingly collect personal information about individuals under the age of 18.</p>
                    </section>

                    <section>
                        <h2>WHAT IS PERSONAL INFORMATION?</h2>
                        <p>"Personal information" means information about an identifiable individual. In general, the Company collects the following types of personal information:</p>
                        <ul>
                            <li>Identity information (such as your full name, or government issued photo identification)</li>
                            <li>Demographic information (such as your age or gender)</li>
                            <li>Contact information (such as your email address or phone number)</li>
                            <li>Location information</li>
                            <li>Professional information</li>
                            <li>Banking or financial information</li>
                            <li>Transaction information</li>
                        </ul>
                    </section>

                    <section>
                        <h2>CONTACTING THE COMPANY</h2>
                        <p>If you have any questions or concerns about this policy, please contact us at privacy@wildchipspoker.com.</p>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Privacy;
